import React from 'react';

const Skeleton = ({ count, circle, containerStyle, skeletonStyle, variant }) => {
  return (
    <div className="comp-skeleton" style={containerStyle}>
      {Array(count)
        .fill(0)
        .map((_, i) => (
          <div key={i} className={`item ${variant || ''}${circle ? 'circle' : ''}`} style={skeletonStyle} />
        ))}
    </div>
  );
};

export default Skeleton;
